import React from "react";
import { useLocation } from "react-router-dom";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Auth() {
    let queryParams = useQuery();
    const token = queryParams.get("token");
    const redirectUrl = queryParams.get("redirectUrl");
    localStorage.setItem("token", token!);

    window.location.replace(redirectUrl!);

    return (
        <></>
    );
}

export default Auth;